import {
    GET_PRODUCT_LOADING,
    GET_PRODUCT_SUCCESS,
    GET_PRODUCT_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    merchants: null,
  };
  
  export const getProductListReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_PRODUCT_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_PRODUCT_SUCCESS:
        return {
          ...state,
          loading: false,
          merchants: action.payload,
          error: null,
        };
      case GET_PRODUCT_FAILED:
        return {
          ...state,
          loading: false,
          merchants: null,
          error: action.error,
        };
       
      default:
        return state;
    }
  };
  